var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWebappUpload = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#webapp_upload_svg__a)",
  stroke: "#3A434A",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.81 5.568a4.246 4.246 0 0 1 3.733-3.742c1.45-.162 2.939-.3 4.457-.3 1.518 0 3.007.138 4.457.3a4.246 4.246 0 0 1 3.733 3.742c.154 1.442.284 2.923.284 4.432 0 1.51-.13 2.99-.284 4.432a4.246 4.246 0 0 1-3.733 3.742c-1.45.162-2.939.3-4.457.3-1.518 0-3.007-.138-4.457-.3a4.246 4.246 0 0 1-3.733-3.742c-.154-1.442-.285-2.923-.285-4.432 0-1.51.13-2.99.285-4.432Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 13.817V6.183M13.193 8.923c-.97-1.225-1.631-1.796-2.616-2.542a.94.94 0 0 0-1.154 0c-.985.746-1.646 1.317-2.616 2.542",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "webapp_upload_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})))));
export default SvgWebappUpload;